/* eslint-disable react/prop-types */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import vlog from '../../javascript/vlog';
import Following from './following';
import { authenticatedHeadersHash } from '../../javascript/v2_authentication';
import withV2HealthCheck from '../with_v2_health_check';

function Index({ userId }) {
  const [v2UserProfileId, setV2UserProfileId] = useState(null);
  const [v2UserId, setV2UserId] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchV2identifiers = async () => {
      try {
        const { data, error: fetchError } = await window.supabaseClient
          .from('user_profiles')
          .select('profile_id, user_id')
          .eq('user_migrate_id', userId)
          .single(); // We expect only one profile per user

        if (fetchError) {
          vlog.error('Error fetching user profile:', fetchError);
          setLoading(false);
          return null;
        }

        if (data?.profile_id && data?.user_id) {
          setV2UserProfileId(data.profile_id);
          setV2UserId(data.user_id);
          setLoading(false);
          return true;
        }
        vlog.error('V2 IDs not found!');
        setLoading(false);
        return null;
      } catch (fetchError) {
        vlog.error('Error fetching V2 IDs', fetchError);
        setLoading(false);
        return null;
      }
    };

    fetchV2identifiers();
  }, [userId]);

  if (loading) return null;

  return (
    <div>
      {error && (
        <div className="alert alert-warning">
          Under Maintenance: please come back later.
        </div>
      )}
      {!error && (
        <div>
          <Following
            authenticatedHeadersHash={authenticatedHeadersHash()}
            profileId={v2UserProfileId}
            setError={setError}
            userId={v2UserId}
          />
        </div>
      )}
    </div>
  );
}

Index.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default withV2HealthCheck(Index);
